export enum COMMON_ROUTES {
  HOME = "/",
  ABOUT_US = "/about-us",
  CONTACT = "/contact-us",
  CAREER = "/career",
  PRODUCT_HEALTH = "/health-insurance",
  PRODUCT_CAR = "/car-insurance",
  PRODUCT_TW = "/two-wheeler-insurance",
  PRODUCT_TERM = "/term-insurance",
  TERM_AND_CONDTION = "/terms-and-conditions",
  CLAIM = "/claim",
  COMPLAINT = "/complaint",
  PRIVACY_POLICY = "/privacy-policy",
  DISCLAIMER = "/disclaimer",
  REFUND_CANCELATION = "/refund-cancelation",
  GRIEVANCE_POLICY = "/grievance-policy",
  SITE_MAP = "/site-map",

  // dummy paths for quotes, will be removed after development
  CAR_QUOTE = "/car-quote",
  TW_QUOTE = "/tw-quote",
  HEALTH_QUOTE = "/health-quote",
  TERM_QUOTE = "/term-quote",
  PLAN_FEATURES_HEALTH = "/health-quote/plan-features",
  PLAN_FEATURES_TERM = "/term-quote/plan-features",

  HEALTH_FORM = "/form/container/health/form",
  CAR_FORM = "/form/container/car/form",
  TW_FORM = "/form/container/tw/form",
  HOME_FORM = "/form/container/home/form",
  TERM_FORM = "/form/container/term/form",

  // HEALTH_FORM = "/form/health-insurance-form",
  // CAR_FORM = "/form/car-insurance-form",
  // TW_FORM = "/form/two-wheeler-form",
  // TERM_FORM = "/form/term-insurance-form",
}
